
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/professional-liability",
      function () {
        return require("private-next-pages/professional-liability.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/professional-liability"])
      });
    }
  